import React from 'react';
import SearchBar from './Search';
import Logo from './Logo';
import Filters from './Filters';
import { connect, useDispatch } from 'react-redux';
import {getList, getTotal} from '../../redux/actions/actions'
import DropDownArea from './DropDownArea';
import MainMenu from './MainMenu'
function Header() {
    //getList();
    const dispatch = useDispatch();
    dispatch(getTotal());
    return (
        <div className="header">

            <Logo />
            <SearchBar />
            <Filters />
            <DropDownArea />
            <MainMenu />
        </div>
    );
}

//export default Header
export default connect(
    null,
    {getList, getTotal}
  )(Header);
